import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import { getAllCustomData } from 'shared/components/App/Auth'
import Store from 'redux/Store'
import { setCustomData, setMessage } from 'shared/redux/actions'

const acceptEula = () => {
    
    const catchFunc = (err: AxiosError) => {
        displayGenError({ setShowOverlay: () => { } })
    }

    axiosPost(
        apiUrls.actionAcceptEula,
        {},
        catchFunc,
    ).then((data) => {
        if (data?.status !== undefined && data.status === 200) {

            // save EULA state for user
            const customerData = getAllCustomData()
            customerData.eulaAccepted = 1
            Store.dispatch(setCustomData(customerData))
            Store.dispatch(setMessage('EULA accepted.', 'success', 'delayed'))

            window.location.reload()
        }
    })
    
}


export default acceptEula